import { ActionMeta } from 'react-select/dist/declarations/src/types'
import React from 'react'
import { Sentiment, TooltipSelectOption } from './tooltip-select.model'
import * as tooltipSelectSelectors from './tooltip-select.selector'

export const saveDataToTextField = (selectedData: TooltipSelectOption[]) => {
	const saveField: HTMLElement = tooltipSelectSelectors.getSaveDataField()
	const optionsToSave = selectedData
		.filter((option) => option.selected)
		.map((option) => ({ value: option.value, sentiment: option.sentiment }))

	saveField.innerHTML = JSON.stringify(optionsToSave)
}

export const handleSetSentiment = (
	options: TooltipSelectOption[] | null,
	newSentiment: Sentiment,
	value: string,
	setOptions: React.Dispatch<React.SetStateAction<TooltipSelectOption[] | null>>,
	setMenuIsOpen: React.Dispatch<React.SetStateAction<boolean>>,
) => {
	if (!options) return

	const updatedData: TooltipSelectOption[] = options.map((option) =>
		option.value === value ? { ...option, sentiment: newSentiment } : { ...option },
	)

	saveDataToTextField(updatedData)
	setOptions([...updatedData])
	setMenuIsOpen(true)
}

export const handleOptionChange = (
	options: TooltipSelectOption[] | null,
	action: ActionMeta<TooltipSelectOption>,
	setOptions: React.Dispatch<React.SetStateAction<TooltipSelectOption[] | null>>,
) => {
	if (!options) return

	let updatedOptions: TooltipSelectOption[] = []

	if (action.action === 'select-option') {
		updatedOptions = options.map((option) => {
			const { selected, sentiment, ...restOfOptions } = option
			if (option.value === action.option?.value) {
				return { ...restOfOptions, sentiment, selected: true }
			}

			return { ...option }
		})
	}

	if (action.action === 'remove-value') {
		updatedOptions = options.map((option) => {
			const { selected, ...restOfOptions } = option
			if (option.value === action.removedValue.value) {
				return { ...restOfOptions, selected: false }
			}

			return { ...option }
		})
	}

	if (action.action === 'clear') {
		updatedOptions = options.map((option) => {
			const { selected, ...restOfOptions } = option
			return { ...restOfOptions, selected: false }
		})
	}

	setOptions([...updatedOptions])
	saveDataToTextField(updatedOptions)
}
